export default "__VITE_ASSET__Boap0Di7__"